import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    seconds: 0,                       
    badgeShownInSecondQuestion: false,
    badgeShownInSeventhQuestion: false,
    badgeShownInFirstQuestion: false,
    timerStartedAt: null,
    firstBadgeOnCertificate: false,
    secondBadgeOnCertificate: false,
    thirdBadgeOnCertificate: false,
    fourthBadgeOnCertificate: false,
    recievedLevelOneBadge: false,
    recievedLevelTwoBadge: false,
    levelTwoBadge: false,
    levelThreeBadge: false,
    interviewCompleteBadge: false,
    showPrgressBarText: true,
    expertIntroFirstCardAnimation: true,
    expertIntroSecondCardAnimation: true,
    expertIntroThirdCardAnimation: true,
    expertIntroCardPlayedOnce: false,
    showInitialExpertCard: true,
    bottomBadgeSentence: ''
}

const badgeSlice = createSlice({
    name: 'badgeSlice',
    initialState,
    reducers: {
        startTimer: (state) => {
            state.timerStartedAt = Date.now();  // Start timer at Q1
        },
        stopTimerAndCalculate: (state) => {
            if (state.timerStartedAt) {
                const now = Date.now()
                state.seconds = Math.floor((now - state.timerStartedAt) / 1000)
                state.timerStartedAt = null
            }
        },
        setBadgeShownInSecondQuestion: (state) => {
            state.badgeShownInSecondQuestion = true
        },
        setBadgeShownInSeventhQuestion: (state) => {
            state.badgeShownInSeventhQuestion = true
        },
        setBadgeShownInFirstQuestion: (state) => {
            state.badgeShownInFirstQuestion = true
        },
        setFirstBadgeOnCertificate: (state) => {
            state.firstBadgeOnCertificate = true
        },
        setSecondBadgeOnCertificate: (state) => {
            state.secondBadgeOnCertificate = true
        },
        setThirdBadgeOnCertificate: (state) => {
            state.thirdBadgeOnCertificate = true
        },
        setRecievedLevelOneBadge: (state) => {
            state.recievedLevelOneBadge = true
        },
        setRecievedLevelTwoBadge: (state) => {
            state.recievedLevelTwoBadge = true
        },
        setLevelTwoBadge: (state) => {
            state.levelTwoBadge = true
        },
        setLevelThreeBadge: (state) => {
            state.levelThreeBadge = true
        },
        setInterviewCompleteBadge: (state) => {
            state.interviewCompleteBadge = true
        },
        setFourthBadgeOnCertificate: (state) => {
            state.fourthBadgeOnCertificate = true
        },
        setShowPrgressBarText: (state) => {
            state.showPrgressBarText = false
        },
        setExpertIntroFirstCardAnimation: (state, action) => {
            state.expertIntroFirstCardAnimation = action.payload
        },
        setExpertIntroSecondCardAnimation: (state, action) => {
            state.expertIntroSecondCardAnimation = action.payload
        },
        setExpertIntroThirdCardAnimation: (state, action) => {
            state.expertIntroThirdCardAnimation = action.payload
        },
        setExpertIntroCardPlayedOnce: (state, action) => {
            state.expertIntroCardPlayedOnce = action.payload
        },
        setShowInitialExpertCard: (state, action) => {
            state.showInitialExpertCard = action.payload
        },
        setBottomBadgeSentence: (state, action) => {
            state.bottomBadgeSentence = action.payload
        },
        resetBadgeState: () => initialState
    }
});

export const {
    startTimer,
    stopTimerAndCalculate,
    setBadgeShownInSecondQuestion,
    setBadgeShownInSeventhQuestion,
    setBadgeShownInFirstQuestion,
    setFirstBadgeOnCertificate,
    setSecondBadgeOnCertificate,
    setThirdBadgeOnCertificate,
    setRecievedLevelOneBadge,
    setRecievedLevelTwoBadge,
    setLevelTwoBadge,
    setLevelThreeBadge,
    setInterviewCompleteBadge,
    setFourthBadgeOnCertificate,
    setShowPrgressBarText,
    setExpertIntroFirstCardAnimation,
    setExpertIntroSecondCardAnimation,
    setExpertIntroThirdCardAnimation,
    setExpertIntroCardPlayedOnce,
    setShowInitialExpertCard,
    setBottomBadgeSentence,
    resetBadgeState
} = badgeSlice.actions

export const selectBadgeDetails = (state) => state.badge
export default badgeSlice.reducer
